/* Pulipelo — interactions */
(function () {
  function afterPaint(fn) { window.requestAnimationFrame(function () { setTimeout(fn, 0); }); }
  function initSliders(root) {
    root.querySelectorAll('[data-bs-slider]').forEach(function (el) {
      if (el.dataset.bsReady) return;
      el.dataset.bsReady = '1';
      var track = el.querySelector('[data-bs-track]');
      if (!track) return;
      var slides = function () { return track.querySelectorAll('[data-bs-slide]'); };
      var dotsWrap = el.querySelector('[data-bs-dots]');
      var step = function () {
        var s = slides();
        if (s.length < 2) return track.clientWidth;
        return s[1].offsetLeft - s[0].offsetLeft;
      };
      var index = function () { return Math.round(track.scrollLeft / step()); };
      var maxIndex = function () {
        return Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / step()));
      };
      var go = function (i) {
        var m = maxIndex();
        if (i > m) i = 0;
        if (i < 0) i = m;
        track.scrollTo({ left: i * step(), behavior: 'smooth' });
      };
      var renderDots = function () {
        if (!dotsWrap) return;
        var n = maxIndex() + 1;
        if (dotsWrap.children.length !== n) {
          dotsWrap.innerHTML = '';
          for (var i = 0; i < n; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'bs-dot';
            b.setAttribute('aria-label', 'Slide ' + (i + 1));
            (function (j) { b.addEventListener('click', function () { go(j); }); })(i);
            dotsWrap.appendChild(b);
          }
        }
        var cur = index();
        Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
          d.classList.toggle('is-active', i === cur);
        });
      };
      var prev = el.querySelector('[data-bs-prev]');
      var next = el.querySelector('[data-bs-next]');
      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      var rq = false;
      track.addEventListener('scroll', function () { if (rq) return; rq = true; window.requestAnimationFrame(function () { rq = false; renderDots(); }); }, { passive: true });
      window.addEventListener('resize', renderDots);
      renderDots();
      var sec = parseInt(el.dataset.autoplay || '0', 10);
      if (sec > 0) {
        var paused = false, inView = true;
        if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { inView = es[es.length - 1].isIntersecting; }).observe(el);
        el.addEventListener('mouseenter', function () { paused = true; });
        el.addEventListener('mouseleave', function () { paused = false; });
        el.addEventListener('touchstart', function () { paused = true; }, { passive: true });
        setInterval(function () { if (!paused && inView && !document.hidden) go(index() + 1); }, sec * 1000);
      }
    });
  }

  function initModals(root) {
    root.querySelectorAll('[data-bs-open]').forEach(function (btn) {
      if (btn.dataset.bsReady) return;
      btn.dataset.bsReady = '1';
      btn.addEventListener('click', function () {
        var d = document.getElementById(btn.dataset.bsOpen);
        if (d && d.showModal) d.showModal();
      });
    });
    root.querySelectorAll('dialog.bs-modal').forEach(function (d) {
      if (d.dataset.bsReady) return;
      d.dataset.bsReady = '1';
      var downOut = false;
      d.addEventListener('pointerdown', function (e) { downOut = e.target === d; });
      d.addEventListener('click', function (e) {
        if (e.target.closest('[data-bs-close]') || (e.target === d && downOut)) d.close();
      });
    });
  }

  function parseJSON(el, fallback) {
    try { return el ? JSON.parse(el.textContent) : fallback; } catch (e) { return fallback; }
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function lines(txt) {
    return String(txt || '').split(/\n/).map(function (l) {
      var p = l.split('|');
      return p.length >= 2 ? { label: p[0].trim(), val: p.slice(1).join('|').trim() } : null;
    }).filter(Boolean);
  }

  function initBundles(root) {
    root.querySelectorAll('[data-bs-bundles]').forEach(function (wrap) {
      if (wrap.dataset.bsReady) return;
      wrap.dataset.bsReady = '1';
      var qty = wrap.querySelector('[data-bs-qty]');
      var data = parseJSON(wrap.querySelector('[data-bs-product]'), { options: [], variants: [] });
      var hex = {};
      lines(String(parseJSON(wrap.querySelector('[data-bs-swatches]'), '') || '').replace(/:/g, '|')).forEach(function (o) { hex[o.label.toLowerCase()] = o.val; });
      var opts = data.options || [];
      var sizeIdx = opts.indexOf(wrap.dataset.sizeLabel);
      var colorIdx = opts.indexOf(wrap.dataset.colorLabel);
      var values = function (idx) {
        var out = [];
        if (idx < 0) return out;
        data.variants.forEach(function (v) { var x = v.options[idx]; if (x != null && out.indexOf(x) < 0) out.push(x); });
        return out;
      };
      var sizes = values(sizeIdx), colors = values(colorIdx);
      var limited = (wrap.dataset.limited || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var defSize = sizes.indexOf(wrap.dataset.defaultSize) >= 0 ? wrap.dataset.defaultSize : sizes[0];
      var state = [];

      var findVariant = function (s, c) {
        for (var i = 0; i < data.variants.length; i++) {
          var v = data.variants[i];
          if ((sizeIdx < 0 || v.options[sizeIdx] === s) && (colorIdx < 0 || v.options[colorIdx] === c)) return v;
        }
        return null;
      };
      var thumbFor = function (s, c) {
        var v = findVariant(s, c);
        return (v && v.img) || wrap.dataset.thumb || '';
      };
      var count = function () { return parseInt(qty ? qty.value : '1', 10) || 1; };

      var render = function () {
        var n = count();
        while (state.length < n) state.push({ s: state.length ? state[state.length - 1].s : defSize, c: colors[0] });
        wrap.querySelectorAll('[data-bs-items]').forEach(function (box) { box.innerHTML = ''; });
        if (!sizes.length && !colors.length) return;
        var sel = wrap.querySelector('.bsb-card.is-selected [data-bs-items]');
        if (!sel) return;
        var html = '<span class="bsb-items__bar"><span class="bsb-items__lbl">' + esc([wrap.dataset.colorLabel, wrap.dataset.sizeLabel].filter(Boolean).join(', ')) + '</span>' +
          '<button type="button" class="bsb-findbtn" data-bs-open-finder><span class="ms">straighten</span>' + esc(wrap.dataset.finderBtn || 'Trova la sua taglia') + '</button></span>';
        for (var i = 0; i < n; i++) {
          var st = state[i];
          html += '<span class="bsb-row" data-i="' + i + '">' +
            '<span class="bsb-row__n">#' + (i + 1) + '</span>' +
            '<span class="bsb-row__thumb">' + (thumbFor(st.s, st.c) ? '<img src="' + esc(thumbFor(st.s, st.c)) + '" alt="">' : '') + '</span>';
          if (colors.length) {
            html += '<span class="bsb-sel bsb-sel--color"><span class="bsb-dot" style="background:' + esc(hex[st.c.toLowerCase()] || '#ddd') + '"></span><select data-k="c" aria-label="' + esc(wrap.dataset.colorLabel) + ' #' + (i + 1) + '">';
            colors.forEach(function (c) { html += '<option value="' + esc(c) + '"' + (c === st.c ? ' selected' : '') + '>' + esc(c) + '</option>'; });
            html += '</select></span>';
          }
          if (sizes.length) {
            html += '<span class="bsb-sel bsb-sel--size"><select data-k="s" aria-label="' + esc(wrap.dataset.sizeLabel) + ' #' + (i + 1) + '">';
            sizes.forEach(function (s) {
              html += '<option value="' + esc(s) + '"' + (s === st.s ? ' selected' : '') + '>' + esc(s) + '</option>';
            });
            html += '</select></span>';
          }
          html += '</span>';
        }
        sel.innerHTML = html;
      };

      var updateRow = function (row) {
        var i = +row.dataset.i, st = state[i];
        var dot = row.querySelector('.bsb-dot');
        if (dot) dot.style.background = hex[st.c.toLowerCase()] || '#ddd';
        var th = row.querySelector('.bsb-row__thumb');
        var src = thumbFor(st.s, st.c);
        if (th) th.innerHTML = src ? '<img src="' + esc(src) + '" alt="">' : '';
      };

      wrap.addEventListener('change', function (e) {
        var t = e.target;
        if (t.type === 'radio') {
          wrap.querySelectorAll('.bsb-card').forEach(function (l) { l.classList.toggle('is-selected', l.contains(t)); });
          if (qty) qty.value = t.value;
          wrap.querySelectorAll('[data-bs-items]').forEach(function (box) { box.innerHTML = ''; });
          afterPaint(render);
        } else if (t.tagName === 'SELECT' && t.dataset.k) {
          var row = t.closest('.bsb-row');
          state[+row.dataset.i][t.dataset.k] = t.value;
          updateRow(row);
          if (t.dataset.k === 'c') {
            var vv = findVariant(state[+row.dataset.i].s, t.value);
            var sid = (wrap.dataset.form || '').replace('product-form-', '');
            var gal = document.querySelector('media-gallery[id^="MediaGallery-' + sid + '"]') || document.querySelector('media-gallery');
            if (vv && vv.mid && gal && gal.setActiveMedia) {
              var keepY = window.scrollY;
              afterPaint(function () {
                try { gal.setActiveMedia(sid + '-' + vv.mid, false); } catch (err) {}
                [0, 30, 120, 300].forEach(function (d) { setTimeout(function () { window.scrollTo({ top: keepY, behavior: 'instant' }); }, d); });
              });
            }
          }
        }
      });
      wrap.addEventListener('click', function (e) {
        if (e.target.closest('[data-bs-open-finder]')) {
          e.preventDefault();
          var m = wrap.querySelector('[data-bs-finder-modal]');
          if (m && m.showModal) m.showModal();
          return;
        }
        if (e.target.closest('.bsb-items') && !/^(SELECT|OPTION)$/.test(e.target.tagName)) e.preventDefault();
      });

      var modal = wrap.querySelector('[data-bs-finder-modal]');
      if (modal) {
        var cfg = parseJSON(wrap.querySelector('[data-bs-finder]'), {});
        var texts = parseJSON(modal.querySelector('[data-bs-f-texts]'), {});
        var wList = lines(cfg.weight), hList = lines(cfg.height);
        var wSel = modal.querySelector('[data-bs-f-weight]'), hSel = modal.querySelector('[data-bs-f-height]');
        wList.forEach(function (o, i) { wSel.insertAdjacentHTML('beforeend', '<option value="' + i + '">' + esc(o.label) + '</option>'); });
        hList.forEach(function (o, i) { hSel.insertAdjacentHTML('beforeend', '<option value="' + i + '">' + esc(o.label) + '</option>'); });
        var res = modal.querySelector('[data-bs-f-result]'), applied = modal.querySelector('[data-bs-f-applied]');
        var compute = function () {
          applied.hidden = true;
          if (wSel.value === '') { res.className = 'bsb-f-result'; res.textContent = res.dataset.empty; return; }
          if (sizes.indexOf(wList[+wSel.value].val) < 0) { res.className = 'bsb-f-result is-done'; res.innerHTML = '<span class="bsb-f-note">' + esc(texts.early || '') + '</span>'; return; }
          if (hSel.value === '') { res.className = 'bsb-f-result'; res.textContent = res.dataset.half; return; }
          var a = sizes.indexOf(wList[+wSel.value].val), b = sizes.indexOf(hList[+hSel.value].val);
          var size = sizes[Math.max(a, b, 0)];
          var isLim = limited.indexOf(size) >= 0;
          res.className = 'bsb-f-result is-done';
          res.innerHTML = '<span class="bsb-f-r1">' + esc(texts.result || '') + '</span>' +
            '<span class="bsb-f-size">' + esc(size) + '</span>' +
            '<span class="bsb-f-stock' + (isLim ? ' is-limited' : '') + '">' + esc(isLim ? texts.limited : texts.instock) + '</span>' +
            '<span class="bsb-f-note">' + esc(texts.note || '') + '</span>';
          for (var i = 0; i < state.length; i++) state[i].s = size;
          render();
          applied.textContent = String(texts.applied || '').replace('[size]', size);
          applied.hidden = false;
        };
        wSel.addEventListener('change', compute);
        hSel.addEventListener('change', compute);
        modal.addEventListener('click', function (e) {
          if (e.target.closest('[data-bs-close]')) modal.close();
        });
      }

      document.addEventListener('submit', function (e) {
        if (!e.target || !e.target.getAttribute || e.target.getAttribute('id') !== wrap.dataset.form) return;
        if (!sizes.length && !colors.length) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var n = count();
        var counts = {}, order = [];
        for (var i = 0; i < n; i++) {
          var v = findVariant(state[i].s, state[i].c);
          if (!v) continue;
          if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
          counts[v.id]++;
        }
        var items = order.map(function (id) { return { id: id, quantity: counts[id] }; });
        var ebv = +wrap.dataset.ebook; if (ebv && n >= (+wrap.dataset.ebookMin || 2)) items.push({ id: ebv, quantity: 1 });
        var btn = e.target.querySelector('[type="submit"]');
        var stopLoad = function () { if (!btn) return; btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); var sp = btn.querySelector('.loading__spinner'); if (sp) sp.classList.add('hidden'); };
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); var sp0 = btn.querySelector('.loading__spinner'); if (sp0) sp0.classList.remove('hidden'); }
        var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res && res.status && res.status !== 200) {
            stopLoad();
            var box = e.target.closest('product-form') && e.target.closest('product-form').querySelector('.product-form__error-message-wrapper');
            if (box) { box.hidden = false; var m = box.querySelector('.product-form__error-message'); if (m) m.textContent = res.description || res.message || 'Errore'; }
            return;
          }
          stopLoad();
          if (window.BSCart) window.BSCart.open(); else window.location.href = rootUrl + 'cart';
        }).catch(function () { stopLoad(); });
      }, true);

      render();
    });
  }

  function initSticky(root) {
    root.querySelectorAll('[data-bs-sticky]').forEach(function (bar) {
      if (bar.dataset.bsReady) return;
      bar.dataset.bsReady = '1';
      document.querySelectorAll('body > .bs-sticky').forEach(function (old) { if (old !== bar) old.remove(); });
      document.body.appendChild(bar);
      var offset = parseInt(bar.dataset.offset || '500', 10);
      var mainOut = null, ticking = false;
      var stBtn = bar.querySelector('[data-bs-sticky-btn]');
      var stForm = stBtn && document.getElementById(stBtn.dataset.form);
      var main = stForm && stForm.querySelector('[type="submit"]');
      var update = function () {
        var show = window.scrollY > offset;
        if (mainOut) { show = mainOut.above || mainOut.below; if (mainOut.below && window.scrollY < offset) show = false; }
        bar.classList.toggle('is-visible', show);
      };
      if (main && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var e = es[es.length - 1], r = e.boundingClientRect, vh = e.rootBounds ? e.rootBounds.height : window.innerHeight;
          mainOut = e.isIntersecting ? { above: false, below: false } : { above: r.bottom <= 0, below: r.top >= vh };
          update();
        }).observe(main);
      }
      window.addEventListener('scroll', function () { if (ticking) return; ticking = true; window.requestAnimationFrame(function () { ticking = false; update(); }); }, { passive: true });
      update();
      var btn = bar.querySelector('[data-bs-sticky-btn]');
      if (btn) btn.addEventListener('click', function () {
        var form = document.getElementById(btn.dataset.form);
        var submit = form && form.querySelector('[type="submit"]');
        if (submit) submit.click();
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  function init(root) {
    root = root || document;
    initSliders(root);
    initModals(root);
    initBundles(root);
    initSticky(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { init(document); });
})();

/* Video fiche produit : lecture au clic */
document.addEventListener('click', function (e) {
  var box = e.target.closest('[data-bs-pvid]');
  if (!box) return;
  var v = box.querySelector('video');
  if (!v) return;
  if (v.paused) {
    document.querySelectorAll('[data-bs-pvid] video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('[data-bs-pvid]').classList.remove('is-playing'); } });
    v.muted = false; v.play(); box.classList.add('is-playing');
  } else { v.pause(); box.classList.remove('is-playing'); }
});
